// extracted by mini-css-extract-plugin
export var resizer = "_cy-0";